'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _actionsMcu = require('../actions/mcu');
function janusConfig(state, action) {
  if (state === undefined) state = {};
  switch (action.type) {
    case _actionsMcu.CREATE_SESSION:
      var config = action.config;
      return Object.assign({}, state, config);
    default:
      return state;
  }
}
function mcu(state, action) {
  if (state === undefined) state = {};
  switch (action.type) {
    case _actionsMcu.CREATE_SESSION_SUCCESS:
      var janus = action.janus;
      return Object.assign({}, state, {
        janus: janus,
        connected: true
      });
    case _actionsMcu.CREATE_SESSION_ERROR:
      return Object.assign({}, state, {
        error: action,
        connected: false
      });
    default:
      return state;
  }
}
exports['default'] = {
  janusConfig: janusConfig,
  mcu: mcu
};
module.exports = exports['default'];